<label class="btn-switch" [class.is-revert]="isRevert" [class.is-invalid]="isInvalid" [class.is-disabled]="isDisabled" data-cy="SwitchButton">
	<input #input type="checkbox" [class.checked]="checked" [attr.checked]="checked ? true : undefined" [disabled]="isDisabled" (change)="onChange($event)">
	<span class="btn-switch-handle" [title]="(checked ? onLabel : offLabel) | translate"></span>
	@if (!noLabel) {
		<span class="btn-switch-label"><span [innerHTML]="label | translate | safe:labelTrust"></span>@if (tooltipMessage) { <i class="far fa-info-circle ml-1" [ngbTooltip]="tooltipMessage | translate"></i> }</span>
	}
</label>
